export const WEB_SEARCH_QUERY_KEY = 'webSearchSites';

export const WEB_SEARCH_SETTINGS_QUERY_KEY = 'webSearchSettings';
